'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');
var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n      @media (', ': ', 'em) {\n        ', '\n      }'], ['\n      @media (', ': ', 'em) {\n        ', '\n      }']);
var _styledComponents = require('styled-components');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var max = 'max-width';
var min = 'min-width';

/* eslint-disable */
var mediaQueryConfig = [{
  label: 'doubleExtraLarge',
  size: 1200,
  query: min
}, {
  label: 'extraLarge',
  size: 1200,
  query: max
}, {
  label: 'large',
  size: 992,
  query: max
}, {
  label: 'medium',
  size: 768,
  query: max
}, {
  label: 'small',
  size: 576,
  query: max
}, {
  label: 'fontMax',
  size: 1024,
  query: max
}, {
  label: 'fontMin',
  size: 360,
  query: min
}, {
  label: 'desktop',
  size: 576,
  query: min
}, {
  label: 'tiny',
  size: 320,
  query: max
}];
/* eslint-enable */

var mediaQuery = mediaQueryConfig.reduce(function (acc, item) {
  var label = item.label,
    size = item.size,
    query = item.query;
  var emSize = size / 16;

  // eslint-disable-next-line
  acc[label] = function () {
    return (0, _styledComponents.css)(_templateObject, query, emSize, _styledComponents.css.apply(undefined, arguments));
  };
  return acc;
}, {});
exports.default = mediaQuery;